<!-- HEADER STARTS -->
<ngx-headroom [duration]="500" easing="ease-in-out">
    <div class="custom-border-top"></div>

    <header class="container-xxl px-0-8 shadow-on-scroll">

        <div class="inner-container">
            <!-- Top Offcanvas -->
            <div class="headquarter-offcanvas">
                <span class="py-0-1 screen-reader">

                    {{ language=='English'?'Headquarter':'मुख्यालय' }}
                </span>

            </div>


            <!-- Header -->
            <nav class="navbar navbar-expand-lg setting-nav" aria-label="Offcanvas navbar large">
                <div class="container-fluid justify-content-end align-items-center">
                    <button class="navbar-toggler screen-reader" type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasSetting" aria-controls="offcanvasSetting">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="offcanvas offcanvas-start text-bg-dark" tabindex="-1" id="offcanvasSetting"
                        aria-labelledby="offcanvasSettingLabel">
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title screen-reader" id="offcanvasSettingLabel">Important Links &
                                Settings</h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
                                aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body">
                            <ul class="navbar-nav ms-auto align-items-lg-center">
                                <li class="nav-item">
                                    <div class="side-header">
                                        <div class="theme me-1" (click)="toggleDarkTheme()">
                                            <div title="Theme mode" class="theme-mode">
                                                <input type="radio" name="theame" value="light" class="active" checked>
                                                <span><i class="bi bi-brightness-high-fill"></i></span>
                                            </div>
                                            <div title="Theme mode" class="theme-mode">
                                                <input type="radio" name="theame" value="dark">
                                                <span><i class="bi bi-moon-fill"></i></span>
                                            </div>
                                        </div>
                                        <a href="javascript:void(0);" title="Skip to main content"
                                            class="skip-content"
                                            (click)="scrollToSection('section-New')">{{
                                            'Skiptomaincontent' | translate }}</a>
                                    </div>
                                </li>
                                <span class="side-header side-divider mx-2">|</span>
                                <li class="nav-item">
                                    <div class="side-header">
                                        <div class="d-flex gap-2">
                                            <a href="javascript:void(0);" [attr.title]="language=='English'?'Decrease font size':'फ़ॉन्ट आकार घटाएँ'"
                                                class="" (click)="decreaseFontSize()"><span
                                                    *ngIf="language=='English'">-A</span> <span
                                                    *ngIf="language=='Hindi'">-अ</span> </a>
                                            <a href="javascript:void(0);" [attr.title]="language=='English'?'Reset font size':'फ़ॉन्ट आकार रीसेट करें'" class=""
                                                (click)="resetFontSize()"><span *ngIf="language=='English'">A</span>
                                                <span *ngIf="language=='Hindi'">अ</span></a>
                                            <a href="javascript:void(0);" [attr.title]="language=='English'?'Increase font size':'फ़ॉन्ट आकार बढ़ाएँ'"
                                                class="" (click)="increaseFontSize()"><span
                                                    *ngIf="language=='English'">+A</span> <span
                                                    *ngIf="language=='Hindi'">+अ</span></a>
                                        </div>
                                        <span class="side-header side-divider mx-0">|</span>
                                        <a routerLink="/screenreader" title="Screen Reader" class="screen-reader"><i
                                                class="icon-fci-ereader"></i> {{
                                            'ScreenReader' | translate }}</a>
                                    </div>
                                </li>
                                <span class="side-header side-divider mx-2">|</span>
                                <li class="nav-item">
                                    <div class="side-header">
                                        <a class="language screen-reader" title="English"
                                            (click)="changeLang('English')" *ngIf="language== 'Hindi'">
                                            <i class="bi bi-translate pe-1"></i> {{
                                            language=='Hindi'?'English':'हिंदी' }}
                                        </a>

                                        <a class="language screen-reader" title="हिन्दी" (click)="changeLang('Hindi')"
                                            *ngIf="language== 'English'">
                                            <i class="bi bi-translate pe-1"></i>{{
                                            language=='English'? 'हिंदी' :'English' }}
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </nav>

            <div class="row main-header">
                <div class="col-md-12 px-xl-0">
                    <nav class="navbar side-header-buttons" aria-label="navbar">
                        <form class="d-flex justify-content-end align-items-center gap-5 me-3 me-sm-4">
                            <a href="https://2025.coop/" title="International Year of Cooperatives" target="_blank" class="logo-dark" style="display: none;"><img
                                    src="assets/images/new-logo.jpg" alt="International Year of Cooperatives"
                                    class="g20-image screen-reader"></a>
                            <a href="https://wcd.nic.in/" title="Ministry Of Women & Child Development" target="_blank" class="logo-dark" style="display: none;"><img
                                    src="assets/images/beti-bachao.png" alt="Beti Bachao Beti Padhao"
                                    class="g20-image screen-reader"></a>
                            <a href="https://www.india.gov.in/" title="National Portal of India" target="_blank" class="logo-dark"
                                style="display: none;"><img src="assets/images/nationalEmblem.png" alt="National Emblem"
                                    class="national-emblem screen-reader"></a>
                            <a href="https://2025.coop/" title="International Year of Cooperatives" target="_blank" class="logo-light" style="display: none;"><img
                                src="assets/images/new-logo.jpg" alt="International Year of Cooperatives"
                                class="g20-image screen-reader"></a>
                            <a href="https://wcd.nic.in/" title="Ministry Of Women & Child Development" target="_blank" class="logo-light" style="display: none;">
                                <img src="assets/images/beti-bachao.png" alt="Beti Bachao Beti Padhao"
                                    class="g20-image screen-reader"></a>
                            <a href="https://www.india.gov.in/" title="National Portal of India" target="_blank" class="logo-light"
                                style="display: none;"> <img src="assets/images/nationalEmblemWhite.png"
                                    alt="National Emblem" class="national-emblem screen-reader"></a>
                            <div class="input-group">
                                <input type="text" class="form-control form=control-sm size-20 screen-reader"
                                    placeholder="{{'SearchFCI' | translate}}" #searchfild id="searchfild"
                                    [value]="query_param" name="searchfild">
                                <span class="input-group-text screen-reader">
                                    <a title="Click to search" href="javascript:void();" (click)="GotoGlobalSearch(searchfild)"><i
                                            class="bi bi-search"></i></a></span>
                            </div>
                        </form>

                    </nav>
                    <nav class="navbar navbar-expand-lg mt-2 mt-md-3 mt-lg-3 mt-xl-0 py-md-2 py-lg-2"
                        aria-label="Offcanvas navbar large">
                        <div class="container-fluid">
                            <a class="navbar-brand screen-reader" routerLink="/" title="Food Corporation Of India">
                                <img src="assets/images/FCIlogofinal.svg" alt="Food Corporation Of India" class="logo-dark"
                                    style="display: none;">
                                <img src="assets/images/FCIlogofinal-white.svg" alt="Food Corporation Of India" class="logo-light"
                                    style="display: none;">
                            </a>
                            <div class="d-flex">
                                <button class="navbar-toggler screen-reader ms-3" type="button"
                                    data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2"
                                    aria-controls="offcanvasNavbar2">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                            </div>
                            <div class="offcanvas offcanvas-start text-bg-dark" tabindex="-1" id="offcanvasNavbar2"
                                aria-labelledby="offcanvasNavbar2Label">
                                <div class="offcanvas-header">
                                    <h5 class="offcanvas-title screen-reader" id="offcanvasNavbar2Label">Menu</h5>
                                    <button type="button" class="btn-close btn-close-white screen-reader"
                                        data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                </div>

                                <div class="offcanvas-body">
                                    <ul class="navbar-nav ms-auto align-items-lg-end" *ngIf="language=='English'">

                                        <li class="nav-item dropdown has-megamenu ng-star-inserted">
                                            <a href="javascript:void(0);" data-bs-toggle="dropdown"
                                                class="nav-link dropdown-toggle screen-reader ng-star-inserted"
                                                tabindex="16" aria-expanded="true">
                                                {{ language=='English'?'Explore':'अन्वेषण करना' }}
                                            </a>
                                            <div role="menu"
                                                class="dropdown-menu megamenu megamenu-explore ng-star-inserted"
                                                tabindex="17" data-bs-popper="static">
                                                <div class="row justify-content-xl-center justify-content-md-start g-3">
                                                    <div class="col-lg-2-5 col-md-3 col-12 mt-0 menu-margin-right"
                                                        *ngFor="let item  of zoneRegionList">
                                                        <div class="col-megamenu">
                                                            <a target="_blank"
                                                                [href]="zoneurl+item.zone.vch_demographic_Url">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="bi bi-arrow-up-right me-3 fs-5"></i>
                                                                    <h6 class="title screen-reader">
                                                                        {{language=='English'?item.zone.vch_Demographic_Name:item.zone.vch_Demographic_Name_Hindi}}
                                                                    </h6>
                                                                </div>
                                                            </a>
                                                            <hr>
                                                            <ul class="list-unstyled mt-3">
                                                                <li *ngFor="let region of item.region">
                                                                    <a target="_blank"
                                                                        [href]="regionURL+region.vch_demographic_Url">
                                                                        <div class="d-flex">
                                                                            <i class="bi bi-arrow-up-right me-3"></i>
                                                                            <p class="title screen-reader">{{
                                                                                language=='English'?region.vch_Demographic_Name:region.vch_Demographic_Name_Hindi}}
                                                                            </p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row px-sm-4">
                                                    <hr>
                                                    <div class="col-lg-12">
                                                        <div class="col-megamenu explore-bottom-menu">
                                                            <ul
                                                                class="list-unstyled d-block d-lg-flex gap-5 justify-content-center flex-nowrap align-items-center mt-3">
                                                                <li class="mb-3 mb-lg-0 w-unset me-0">
                                                                    <a href="{{ env.homeURL }}" title="Go To Home"
                                                                        class="d-flex align-items-center">
                                                                        <i class="icon-fci-Vector fs-4 me-3"></i>
                                                                        <p class="title screen-reader">{{'Home' | translate}}</p>
                                                                    </a>
                                                                </li>
                                                                <li class="mb-0 custom-border-end me-0"></li>
                                                                <li class="mb-3 mb-lg-0 w-unset me-0">
                                                                    <a href="{{ env.ifsUrl }}" target="_blank"
                                                                        title="Go To IFS"
                                                                        class="d-flex align-items-center">
                                                                        <i class="icon-fci-building1 fs-4 me-3"></i>
                                                                        <p class="title screen-reader">{{ 'Ifs' | translate }}</p>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="nav-item dropdown has-megamenu"
                                            *ngFor="let loopGlobalHeader of headerGlobalMenu; let i = index;">
                                            <!-- For External Page-->

                                            <a *ngIf='loopGlobalHeader["linkType"]==1' class="nav-link screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown"
                                                (click)='goToExtLink(loopGlobalHeader["externalLink"])'>
                                                {{ htmldecode(loopGlobalHeader["menuNameInEnglish"]) }} </a>
                                            <!-- End of External Page  -->

                                            <!-- For Plugin Page-->
                                            <a *ngIf='loopGlobalHeader["linkType"]==2' class="nav-link screen-reader"
                                                href="javascript:void(0);"
                                                (click)="goToPluginPage(loopGlobalHeader['selectPlugin'],{'plugin_id':loopGlobalHeader['id'],'selectPlugin':loopGlobalHeader['selectPlugin']})"
                                                data-bs-toggle="dropdown">
                                                {{ htmldecode(loopGlobalHeader["menuNameInEnglish"]) }} </a>
                                            <!-- End of Plugin Page  -->

                                            <!-- For Content Page-->
                                            <a *ngIf='loopGlobalHeader["linkType"]==3' class="nav-link screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown"
                                                (click)="goToContentPage(loopGlobalHeader)">
                                                {{ htmldecode(loopGlobalHeader["menuNameInEnglish"]) }} </a>
                                            <!-- End of Content Page  -->

                                            <!-- For NA -->
                                            <a *ngIf='loopGlobalHeader["linkType"]==4'
                                                class="nav-link dropdown-toggle screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown">
                                                {{ htmldecode(loopGlobalHeader["menuNameInEnglish"]) }} </a>
                                            <!-- End of For NA  -->

                                            <div class="dropdown-menu megamenu" role="menu"
                                                *ngIf='loopGlobalHeader["linkType"]==4'>
                                                <div class="row justify-content-start g-3">
                                                    <div class="col-lg-12 col-12 mt-0">
                                                        <div class="col-megamenu">
                                                            <ul class="list-unstyled">
                                                                <ng-container
                                                                    *ngFor="let loopPrimaryHeader of headerPrimaryMenu">

                                                                    <li
                                                                        *ngIf='loopGlobalHeader["id"] == loopPrimaryHeader["globalMenu"]'>


                                                                        <!-- For External Page-->

                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==1'
                                                                            href="javascript:void(0);"
                                                                            (click)='goToExtLink(loopPrimaryHeader["externalLink"])'>
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>

                                                                        <!-- End of External Page  -->


                                                                        <!-- For Plugin Page-->
                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==2'
                                                                            href="javascript:void(0);"
                                                                            (click)="goToPluginPage(loopPrimaryHeader['selectPlugin'],{'plugin_id':loopPrimaryHeader['id'],'selectPlugin':loopPrimaryHeader['selectPlugin']})">
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>
                                                                        <!-- End of Plugin Page  -->


                                                                        <!-- For Content Page-->


                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==3'
                                                                            href="javascript:void(0);"
                                                                            (click)="goToContentPage(loopPrimaryHeader)">
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInEnglish"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>

                                                                        <!-- End of Content Page  -->
                                                                    </li>
                                                                </ng-container>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3 col-12 me-xl-4 mt-0 menu-border-end">
                                                        <div class="col-megamenu me-xl-4">
                                                            <ul class="list-unstyled">
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3 col-12 mt-0">
                                                        <div class="col-megamenu">
                                                            <ul class="list-unstyled">
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>


                                    <ul class="navbar-nav ms-auto align-items-lg-end" *ngIf="language=='Hindi'">

                                        <li class="nav-item dropdown has-megamenu ng-star-inserted">
                                            <a href="javascript:void(0);" data-bs-toggle="dropdown"
                                                class="nav-link dropdown-toggle screen-reader ng-star-inserted"
                                                tabindex="16" aria-expanded="true">
                                                {{ language=='English'?'Explore':'अन्वेषण करना' }}
                                            </a>
                                            <div role="menu"
                                                class="dropdown-menu megamenu megamenu-explore ng-star-inserted"
                                                tabindex="17" data-bs-popper="static">
                                                <div class="row justify-content-xl-center justify-content-md-start g-3">
                                                    <div class="col-lg-2-5 col-md-3 col-12 mt-0 menu-margin-right"
                                                        *ngFor="let item  of zoneRegionList">
                                                        <div class="col-megamenu">
                                                            <a target="_blank"
                                                                [href]="zoneurl+item.zone.vch_demographic_Url">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="bi bi-arrow-up-right me-3 fs-5"></i>
                                                                    <h6 class="title screen-reader">
                                                                        {{language=='English'?item.zone.vch_Demographic_Name:item.zone.vch_Demographic_Name_Hindi}}
                                                                    </h6>
                                                                </div>
                                                            </a>
                                                            <hr>
                                                            <ul class="list-unstyled mt-3">
                                                                <li *ngFor="let region of item.region">
                                                                    <a target="_blank"
                                                                        [href]="regionURL+region.vch_demographic_Url">
                                                                        <div class="d-flex">
                                                                            <i class="bi bi-arrow-up-right me-3"></i>
                                                                            <p class="title screen-reader">{{
                                                                                language=='English'?region.vch_Demographic_Name:region.vch_Demographic_Name_Hindi}}
                                                                            </p>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="row px-sm-4">
                                                    <hr>
                                                    <div class="col-lg-12">
                                                        <div class="col-megamenu explore-bottom-menu">
                                                            <ul
                                                                class="list-unstyled d-block d-lg-flex gap-5 justify-content-center flex-nowrap align-items-center mt-3">
                                                                <li class="mb-3 mb-lg-0 w-unset me-0">
                                                                    <a href="{{ env.homeURL }}" title="Go To Home"
                                                                        class="d-flex align-items-center">
                                                                        <i class="icon-fci-Vector fs-4 me-3"></i>
                                                                        <p class="title screen-reader">{{'Home' | translate}}</p>
                                                                    </a>
                                                                </li>
                                                                <li class="mb-0 custom-border-end me-0"></li>
                                                                <li class="mb-3 mb-lg-0 w-unset me-0">
                                                                    <a href="{{ env.ifsUrl }}" target="_blank"
                                                                        title="Go To IFS"
                                                                        class="d-flex align-items-center">
                                                                        <i class="icon-fci-building1 fs-4 me-3"></i>
                                                                        <p class="title screen-reader">{{ 'Ifs' | translate }}</p>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>



                                        <li class="nav-item dropdown has-megamenu"
                                            *ngFor="let loopGlobalHeader of headerGlobalMenu">
                                            <!-- For External Page-->

                                            <a *ngIf='loopGlobalHeader["linkType"]==1' class="nav-link screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown"
                                                (click)='goToExtLink(loopGlobalHeader["externalLink"])'>
                                                {{ htmldecode(loopGlobalHeader["menuNameInHindi"]) }} </a>
                                            <!-- End of External Page  -->

                                            <!-- For Plugin Page-->
                                            <a *ngIf='loopGlobalHeader["linkType"]==2' class="nav-link screen-reader"
                                                href="javascript:void(0);"
                                                (click)="goToPluginPage(loopGlobalHeader['selectPlugin'],{'plugin_id':loopGlobalHeader['id'],'selectPlugin':loopGlobalHeader['selectPlugin']})"
                                                data-bs-toggle="dropdown">
                                                {{ htmldecode(loopGlobalHeader["menuNameInHindi"]) }} </a>
                                            <!-- End of Plugin Page  -->

                                            <!-- For Content Page-->
                                            <a *ngIf='loopGlobalHeader["linkType"]==3' class="nav-link screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown"
                                                (click)="goToContentPage(loopGlobalHeader)">
                                                {{ htmldecode(loopGlobalHeader["menuNameInHindi"]) }} </a>
                                            <!-- End of Content Page  -->

                                            <!-- For NA -->
                                            <a *ngIf='loopGlobalHeader["linkType"]==4'
                                                class="nav-link dropdown-toggle screen-reader"
                                                href="javascript:void(0);" data-bs-toggle="dropdown">
                                                {{ htmldecode(loopGlobalHeader["menuNameInHindi"]) }} </a>
                                            <!-- End of For NA  -->

                                            <div class="dropdown-menu megamenu" role="menu"
                                                *ngIf='loopGlobalHeader["linkType"]==4'>
                                                <div class="row justify-content-start g-3">
                                                    <div class="col-lg-12 col-12 mt-0">
                                                        <div class="col-megamenu">
                                                            <ul class="list-unstyled">
                                                                <ng-container
                                                                    *ngFor="let loopPrimaryHeader of headerPrimaryMenu">

                                                                    <li
                                                                        *ngIf='loopGlobalHeader["id"] == loopPrimaryHeader["globalMenu"]'>


                                                                        <!-- For External Page-->

                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==1'
                                                                            href="javascript:void(0);"
                                                                            (click)='goToExtLink(loopPrimaryHeader["externalLink"])'>
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInHindi"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>

                                                                        <!-- End of External Page  -->


                                                                        <!-- For Plugin Page-->
                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==2'
                                                                            href="javascript:void(0);"
                                                                            (click)="goToPluginPage(loopPrimaryHeader['selectPlugin'],{'plugin_id':loopPrimaryHeader['id'],'selectPlugin':loopPrimaryHeader['selectPlugin']})">
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInHindi"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>
                                                                        <!-- End of Plugin Page  -->


                                                                        <!-- For Content Page-->


                                                                        <a *ngIf='loopPrimaryHeader["linkType"] ==3'
                                                                            href="javascript:void(0);"
                                                                            (click)="goToContentPage(loopPrimaryHeader)">
                                                                            <div class="d-flex align-items-center">
                                                                                <i
                                                                                    class="bi bi-arrow-up-right me-3"></i>
                                                                                <p class="title screen-reader">
                                                                                    {{htmldecode(loopPrimaryHeader["menuNameInHindi"])}}
                                                                                </p>
                                                                            </div>
                                                                        </a>

                                                                        <!-- End of Content Page  -->
                                                                    </li>
                                                                </ng-container>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3 col-12 me-xl-4 mt-0 menu-border-end">
                                                        <div class="col-megamenu me-xl-4">
                                                            <ul class="list-unstyled">
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3 col-12 mt-0">
                                                        <div class="col-megamenu">
                                                            <ul class="list-unstyled">
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</ngx-headroom>
<!-- HEADER ENDS -->